import $ from 'jquery';
export default function() {
    var productData = {}; // populated via ajax below.
    var codes = []; // List of product codes for which to retrieve data.
    var department = "F"; // Default to women's. Set later when we find out for sure.
    var layoutChangeHandlers = [];
    var defaults = {
        showMoreColorsText: _get(window, 'rcProps.translations.showMoreColorsText', "show more colors for"),
        showLessColorsText: _get(window, 'rcProps.translations.showLessColorsText', "show less colors for")
    };

    $(window).on("resize", onLayoutChange);
    $(window).on("layout-change", onLayoutChange);
    $(window).on("content-load", onContentLoad);
    onContentLoad(); // On initial page load, don't wait for content-load event.

    function _get(object, path, defval = null) {
        if (typeof path === "string") path = path.split(".");
        return path.reduce((xs, x) => (xs && xs[x] ? xs[x] : defval), object);
    }

    function onContentLoad() {

        $("li.products-grid__item").each(function () {
            const $div = $(this);
            const $swatchContainer = $div.find('.js-plp-swatches');
            if ($swatchContainer.length) {
                // make sure to only bind events once
                if($swatchContainer.data('colorSwatchesEvent') === true) {
                    return;
                }
                $swatchContainer.data('colorSwatchesEvent', true);
                createSwatchDropDown($swatchContainer);
            }
            createSwatchClickHandlers($(this));
        });
        if (codes && codes.length > 0) {
            $.ajax({
                url: "/r/ajax/GetSwatchData.jsp",
                dataType: "json",
                type: "POST",
                data: {
                    product: codes,
                    d: department
                },
                success: function (json) {
                    productData = json;
                }
            });
        }
    }

    window.bindColorSwatchEvent = onContentLoad;

    // columnView.js fires a custom event when it changes the layout.
    function onLayoutChange(event) {
        // This doesn't need to be synchronous. Let the event handler return
        // to re-flowing the page.
        window.setTimeout(function() {
            layoutChangeHandlers.forEach(function (f) {
                try { f(event); }
                catch (e) { console.log(e); }
            });
        }, 1);
    }

    function createSwatchClickHandlers($div) {
        var $heart = $div.find('.js-favorite-button');
        var $qv = $div.find(".js-plp-quickview");
        var $img = $div.find(".js-plp-image"); // *Seems to be the only one... need to add class.
        var $altImg = $div.find(".js-plp-altview");
        var $name = $div.find(".js-plp-name");
        var $brand = $div.find(".js-plp-brand");
        var $price = $div.find(".js-plp-price");
        var $link = $div.find(".js-plp-pdp-link");
        var $link2 = $div.find(".js-plp-pdp-link2");
        var $retail = $div.find(".js-plp-price-retail");
        var $swatches = $div.find(".product-swatches__swatch");
        var $badgeContainer = $div.find('.js-badge-container');
        var $similaritemslink = $div.find(".js-plp-similar-items-link");
        $swatches.each(function () {
            var code = $(this).data("code");
            department = $(this).data("department") || department; // Just stomp on the value. Last one wins.
            codes.push(code);
            $(this).click(function () {
                var $colorWay = $(this);
                $swatches.prop('checked',false);        // desktop
                $swatches.removeClass("plp_active_color "); // mobile
                $(this).prop('checked',true);             // desktop
                $(this).addClass("plp_active_color");       // mobile
                if (code in productData) {
                    var prod = productData[code];
                    $img.attr("src", prod.imgPlp);
                    $img.attr("data-src", prod.imgPlp);
                    if (prod.imgPlpRetina) {
                        $img.attr("srcset", prod.imgPlpRetina + " 2x, " + prod.imgPlp + " 1x");
                    } else {
                        $img.attr("srcset", prod.imgPlp + " 2x, " + prod.imgPlp + " 1x");
                    }

                    if (prod.imgHoverView) {
                        $altImg.attr("src", prod.imgHoverView);
                        $altImg.data('lazySrc', prod.imgHoverView);
                        if (prod.imgHoverViewRetina) {
                            $altImg.attr("srcset", prod.imgHoverViewRetina + " 2x, " + prod.imgHoverView + " 1x");
                            $altImg.data('lazySrcset', prod.imgHoverViewRetina + " 2x, " + prod.imgHoverView + " 1x");
                        } else {
                            $altImg.attr("srcset", prod.imgHoverView + " 2x, " + prod.imgHoverView + " 1x");
                            $altImg.data('lazySrcset', prod.imgHoverView + " 2x, " + prod.imgHoverView + " 1x");
                        }
                    }
                    $name.html(prod.name);
                    $brand.html(prod.brand);
                    if(prod.priceMarkup){
                        $div.find('.js-plp-prices-div').html(prod.priceMarkup);
                    }else{
                        $price.html(prod.price);
                        $retail.html(prod.retailPrice);
                    }

                    $badgeContainer.empty();
                    var badgeText = $colorWay.data('badge');
                    if (badgeText) {
                        var badgeHref = $colorWay.data('badgeHref');
                        var badgeTemplate = badgeHref ? $('#linked-badge-template') : $('#unlinked-badge-template');
                        $badgeContainer.append(Mustache.render(badgeTemplate.text(), {
                            badgeText: badgeText,
                            badgeClass: $colorWay.data('badgeClass'),
                            link: badgeHref,
                        }));
                    }
                    $link.prop("href", prod.url);
                    $link2.prop("href", prod.url);
                    $qv.data("code", code); // Updates parameter value to Quick View code.
                    $heart.data("code", code);

                    $similaritemslink.data("code", code);

                    toggleHeart($heart, prod.isFavorite);

                    const productImageContainer = $(this).parents('.products-grid__item').find('.product-grids__image')[0];
                    if($('body').data('plp-model-image-first')) {
                        swapMainAndHoverImagesForProduct(productImageContainer);
                    }

                }
            });
        });
        $heart.click(function() {
            var code = $(this).data("code");
            toggleHeart($heart, isFavorite($heart));
            if (productData[code]) {
                productData[code].isFavorite = !(productData[code].isFavorite);
            }
        });
    }

    function isFavorite($heart){
        return $heart.hasClass('favorite-button--active') || $heart.find('span.fav_heart').hasClass('hearted_active');
    }

    function toggleHeart($heart, isFavorite){
        switch($heart.prop("tagName")) { // On main, we use "button". On mobile, we use "a". Adjust needed class accordingly.
            case "BUTTON":
                $heart.toggleClass("favorite-button--active", isFavorite);
                break;
            default:
                $heart.find("span.fav_heart").toggleClass("hearted_active", isFavorite);
                break;
        }

    }

    function createSwatchDropDown($container) {
        var visible;
        var $toggle;
        var $down;
        var $up;

        function toggleSwatches() {
            visible ? hide() : show();
        };

        function hide() {
            $container.removeClass('product-swatches--plp--active');
            $up.hide();
            $down.show();
            visible = false;
            $container.find('.js-swatch-toggle-text').text(defaults.showMoreColorsText);
        }

        function show() {
            $container.addClass('product-swatches--plp--active');
            $down.hide();
            $up.show();
            visible = true;
            $container.find('.js-swatch-toggle-text').text(defaults.showLessColorsText);
            var $firstSwatch = $container.find('.js-plp-swatch > .product-swatches__radio:eq(7)');
            if ($firstSwatch.length) {
                $firstSwatch.focus();
            } else {
                // If there are less than eight swatches, focus the first one
                $container.find('.js-plp-swatch:first').focus();
            }
        }

        function handleInteraction(event) {
            if (event.type === 'click' || (event.type === 'keydown' && event.keyCode === 13)) {
                event.preventDefault();
                toggleSwatches();
            } else {
                return;
            }
        }

        function init(event) {
            var containerWidth = $container.width();
            var numWide = Math.floor(containerWidth / swatchWidth);

            if (numWide >= numSwatches) {
                $toggle.hide();
            }
            else {
                $toggle.show();
                $up.hide();
                $down.show();
                visible = false;

                $toggle.on('click.swatch', function(event) {
                    const $swatchContainer = $(this).parent().prev();
                    $swatchContainer.find('.js-plp-lazy-swatch-img').each(function() {
                        const $swatch = $(this);
                        $swatch.attr("src", $swatch.data('src'));
                    });
                
                    $(this).off("click.swatch");
                });

                $toggle.on('keydown', function(event) {
                    if (event.keyCode !== 13 && event.keyCode !== 32) {
                        return; 
                    }
                    const $swatchContainer = $(this).parent().prev();
                    $swatchContainer.find('.js-plp-lazy-swatch-img').each(function() {
                        const $swatch = $(this);
                        $swatch.attr("src", $swatch.data('src'));
                    });
                    $(this).off("keydown");
                });
            }
        }

        if ($container.find(".js-plp-swatch").length > 1) {
            visible = false;
            var $swatches = $container.find(".js-plp-swatch");
            $toggle = $container.find(".js-swatch-toggle-container");
            $down = $toggle.find(".js-swatch-toggle-down");
            $up = $toggle.find(".js-swatch-toggle-up");

            var numSwatches = $swatches.length + 1;

            $down.add($up).css('pointer-events', 'none');

            $toggle.on('click', function(event) {
                event.preventDefault(); 
                handleInteraction(event);
            });

            $toggle.on('keydown', function(event) {
                if (event.keyCode === 13 || event.keyCode === 32) {
                    event.preventDefault();
                    handleInteraction(event);
                }
            });

            // Keep some dimensions handy.
            // We can't reliably determine the height of a single row of swatches, since we'd need to take into account
            // padding, margins, etc. $.position() is likewise unreliable since it returns a position relative to the
            // nearest offsetParent, which depends on CSS properties and might not be the actual parent. So we take a
            // good guess: we know how many rows there are, and we figure they're probably devided more-or-less evenly.

            var swatchWidth = $swatches.outerWidth() + Math.max(parseInt($swatches.css("margin-right")), parseInt($swatches.css("margin-left")));
            layoutChangeHandlers.push(init);
            init();

            $down.click(toggleSwatches);
            $up.click(toggleSwatches);
            hide();
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/entry-points/plp/plpswatches.js